export const calculateTotalItemPrice = (item) => {
  let price = parseFloat(item.price);

  for (let i = 0; i < item.responses.length; i++) {
    // handle array of responses (checkboxes)
    if (Array.isArray(item.responses[i].selected_options)) {
      item.responses[i].selected_options.forEach((option) => {
        if (option.price !== null) {
          price += parseFloat(option.price);
        }
      });
      // handle multiple choice
    } else if (typeof item.responses[i].selected_options === "object") {
      if (item.responses[i].selected_options.price !== null) {
        price += parseFloat(item.responses[i].selected_options.price);
      }
    }
  }

  return price.toFixed(2);
};

export const retrieveProductFromShop = (products, cartItem) => {
  let product;
  if (cartItem.use_variants) {
    product =
      products &&
      products.filter(
        (product) =>
          product.use_variants &&
          product.variants.some((variant) => variant.product_id === cartItem.product_id),
      )[0];

    const variantArr = product && product.variants;
    const variant =
      variantArr.length > 0 &&
      variantArr.filter((variant) => variant.product_id === cartItem.product_id)[0];

    product = variant;
  } else {
    product =
      products && products.filter((product) => product.product_id === cartItem.product_id)[0];
  }
  return product;
};

// for time-based products
export const checkProductAvailability = (product) => {
  if (product) {
    if (!product.available_start_time && !product.available_end_time) {
      return true;
    }

    const currentTime = new Date();
    const startTime = new Date(product.available_start_time);
    const endTime = new Date(product.available_end_time);

    if (currentTime < startTime || currentTime > endTime) {
      return false;
    }
    return true;
  }
  return false;
};

export const getPercentageDiscount = (originalPrice, discountedPrice) => {
  if (originalPrice && discountedPrice) {
    const discount = ((originalPrice - discountedPrice) / originalPrice) * 100;
    return "-" + discount.toFixed(0);
  }
  return "";
};
